import { classNames } from "../../shared/utility";
import type { ReactNode } from "react";

export const PillType = {
  Success: "success",
  Error: "error",
  Warning: "warning",
  Gray: "gray",
  DarkYellow: "darkYellow",
  Orange: "orange",
} as const;

export type PillTypeValue = (typeof PillType)[keyof typeof PillType];

interface PillsProps {
  content: {
    text: ReactNode;
    type: PillTypeValue;
  };
}

export default function Pills(props: PillsProps) {
  const { content } = props;

  const getColor = () => {
    var returnString = "";
    switch (content.type) {
      case PillType.Success:
        returnString = "bg-green-600 text-white";
        break;
      case PillType.Error:
        returnString = "bg-red-600 text-white";
        break;
      case PillType.Warning:
        returnString = "bg-yellow-400 text-white";
        break;
      case PillType.DarkYellow:
        returnString = "bg-yellow-600 text-white";
        break;
      case PillType.Orange:
        returnString = "bg-orange-500 text-white";
        break;
      case PillType.Gray:
        returnString = "bg-gray-600 text-white";
        break;
      default:
        break;
    }
    return returnString;
  };

  return (
    // <div
    //   className={classNames(
    //     getColor(),
    //     "rounded-md px-1.5 py-1.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 w-fit"
    //   )}
    // >
    //   {content.text}
    // </div>
    <span
      className={classNames(
        getColor(),
        "inline-flex items-center rounded-md px-3 py-1.5 text-base font-medium"
      )}
    >
      {content.text}
    </span>
  );
}
